import { addMessages } from '@hana/i18n';

// Khoá chuỗi của chi tiết service (ServiceDetail.tsx). Mã service / cảng / hãng, nhãn trạng thái lịch và nhóm (svcmap.ts), nhật ký mẫu không dịch.
addMessages('vi', {
  'sd.fold': 'Mở hoặc gập {v}',
  'sd.foldTip': 'Mở / gập',
  'sdt.noWrite': 'Chưa bật ghi Services Map',
  'sd.tImport': 'Nhập lịch dài hạn',
  'sd.lastTrip': 'chuyến cuối {v}',
  'sd.import': 'Nhập',
  'sd.tBlank': 'Kiểm {n} tuần blank sailing',
  'sd.tBlankSub': '8 tuần tới · tại cảng {v}',
  'sd.viewGrid': 'Xem lưới',
  'sd.tLink': 'Thêm link lịch hãng',
  'sd.tLinkSub': 'dùng để mở lịch {v} nhanh',
  'sdt.add': 'Thêm',
  'sd.tRecon': 'Đối chiếu lịch thực tế tuần này',
  'sd.tReconSub': 'thực tế ↔ lịch dài hạn',
  'sd.sync': 'Đồng bộ',
  'sd.tOk': 'Lịch dài hạn còn hạn',
  'sd.iCode': 'Mã service',
  'sd.iName': 'Tên',
  'sd.iGroup': 'Nhóm · chiều',
  'sd.vnPortL': 'cảng VN {v}',
  'sd.carrier': 'Hãng',
  'sd.iLoop': 'Vòng · tàu',
  'sd.iLoopV': '{a} ngày · {b} tàu · 1 chuyến / tuần',
  'sd.iSched': 'Lịch',
  'sd.lastImported': 'chuyến cuối đã nhập {v}',
  'sd.iProfile': 'Hồ sơ',
  'sd.locked': 'Đã khoá',
  'sd.unlocked': 'Chưa khoá',
  'sd.lLookup': 'Tra Giá và Lịch',
  'sd.lInq': 'Hỏi giá đối tác',
  'sd.lBooking': 'Booking trên service',
  'sd.lSetup': 'Thiết lập giá · cảng chuyển tải',
  'sd.pPricing': 'Pricing · biểu giá và tuyến',
  'sd.unassigned': 'Chưa giao',
  'sd.pBkg': 'BKG · lịch tàu',
  'sd.back': 'Quay lại danh sách service',
  'sd.moreAct': 'Thao tác với service',
  'sd.mLock': 'Khoá hồ sơ',
  'sd.mUnlock': 'Mở khoá hồ sơ',
  'sd.mRename': 'Đổi tên service',
  'sd.mDup': 'Service có thể trùng',
  'sd.mImport': 'Nhập lịch dài hạn',
  'sd.mStop': 'Ngừng theo dõi service',
  'sd.lockedTip': 'Đã khoá hồ sơ · chỉ sửa được lịch tàu',
  'sd.lockedProfile': 'Đã khoá hồ sơ',
  'sd.editSched': 'Sửa lịch tàu',
  'sd.editSvc': 'Sửa service',
  'sd.map': 'Bản đồ rotation',
  'sd.mapTip': 'Bản đồ theo toạ độ cảng (UN/LOCODE). Bấm cảng để xem dòng rotation.',
  'sd.mapSum': 'Bản đồ rotation {c} · {n} cảng',
  'sd.rotation': 'Rotation · chiều {v}',
  'sd.rotTip': 'Thứ tự ghé cảng của service · cảng VN in đậm.',
  'sd.rotSum': '{n} cảng · xuất từ {v}',
  'sd.vnPort': 'cảng VN',
  'sd.tt': 'T/T {n} ngày',
  'sd.noLegDays': 'Chưa khai LegDays từng chặng · nhập từ lịch hãng hoặc Ask HANA đọc Routing Network',
  'sd.carSvc': 'Hãng và service',
  'sd.carSvcTip': 'Hãng khai thác tàu và hãng mua slot (VSA).',
  'sd.operator': 'Khai thác tàu · nhận mọi POD trong rotation',
  'sd.slotBuyer': 'Mua slot (VSA) · POD theo rotation',
  'sd.sched': 'Lịch tàu sắp tới',
  'sd.schedTip': 'Lịch dài hạn 5 tuần tới tại cảng VN.',
  'sd.schedSum': '{a} chuyến · {b} blank',
  'sd.activity': 'Hoạt động',
  'sd.activityTip': 'Lịch sử thay đổi hồ sơ, VSA và lịch của service.',
  'sd.activitySum': '{n} thay đổi · gần nhất {v}',
  'sd.todo': 'Việc cần làm',
  'sd.todoTip': 'Việc còn lại của service này.',
  'sd.todoN': '{n} việc cần làm',
  'sd.noTodo': 'Không còn việc',
  'sd.mainInfo': 'Thông tin chính',
  'sd.mainInfoTip': 'Hồ sơ service (TblService · TblServiceRoute). Hồ sơ khoá thì chỉ sửa được lịch tàu.',
  'sd.owners': 'Người phụ trách',
  'sd.ownersTip': 'Service không gắn khách nên chỉ có người thực hiện (TblOrgJD): Pricing duy trì biểu giá và tuyến, BKG theo dõi lịch tàu.',
  'sd.links': 'Liên kết',
  'sd.linksTip': 'Màn liên quan.',
  'sd.linksSum': '{n} màn liên quan',
});
addMessages('en', {
  'sd.fold': 'Expand or collapse {v}',
  'sd.foldTip': 'Expand / collapse',
  'sdt.noWrite': 'Writing Services Map is not enabled',
  'sd.tImport': 'Import long-term schedule',
  'sd.lastTrip': 'last sailing {v}',
  'sd.import': 'Import',
  'sd.tBlank': 'Check {n} blank-sailing weeks',
  'sd.tBlankSub': 'next 8 weeks · at port {v}',
  'sd.viewGrid': 'View grid',
  'sd.tLink': 'Add carrier schedule link',
  'sd.tLinkSub': 'used to open the {v} schedule quickly',
  'sdt.add': 'Add',
  'sd.tRecon': 'Reconcile this week’s actual schedule',
  'sd.tReconSub': 'actual ↔ long-term schedule',
  'sd.sync': 'Sync',
  'sd.tOk': 'Long-term schedule is valid',
  'sd.iCode': 'Service code',
  'sd.iName': 'Name',
  'sd.iGroup': 'Group · direction',
  'sd.vnPortL': 'VN port {v}',
  'sd.carrier': 'Carrier',
  'sd.iLoop': 'Loop · ships',
  'sd.iLoopV': '{a} days · {b} ships · 1 sailing / week',
  'sd.iSched': 'Schedule',
  'sd.lastImported': 'last imported sailing {v}',
  'sd.iProfile': 'Profile',
  'sd.locked': 'Locked',
  'sd.unlocked': 'Unlocked',
  'sd.lLookup': 'Rates & Schedules',
  'sd.lInq': 'Partner rate inquiries',
  'sd.lBooking': 'Bookings on the service',
  'sd.lSetup': 'Price setup · transshipment ports',
  'sd.pPricing': 'Pricing · tariffs and lanes',
  'sd.unassigned': 'Unassigned',
  'sd.pBkg': 'BKG · sailing schedule',
  'sd.back': 'Back to service list',
  'sd.moreAct': 'Service actions',
  'sd.mLock': 'Lock profile',
  'sd.mUnlock': 'Unlock profile',
  'sd.mRename': 'Rename service',
  'sd.mDup': 'Possible duplicate services',
  'sd.mImport': 'Import long-term schedule',
  'sd.mStop': 'Stop following service',
  'sd.lockedTip': 'Profile locked · only the sailing schedule can be edited',
  'sd.lockedProfile': 'Profile locked',
  'sd.editSched': 'Edit sailing schedule',
  'sd.editSvc': 'Edit service',
  'sd.map': 'Rotation map',
  'sd.mapTip': 'Map by port coordinates (UN/LOCODE). Click a port to see its rotation row.',
  'sd.mapSum': 'Rotation map {c} · {n} ports',
  'sd.rotation': 'Rotation · direction {v}',
  'sd.rotTip': 'Port-call order of the service · VN ports in bold.',
  'sd.rotSum': '{n} ports · outbound from {v}',
  'sd.vnPort': 'VN port',
  'sd.tt': 'T/T {n} days',
  'sd.noLegDays': 'LegDays per leg not declared · import from the carrier schedule or let Ask HANA read the Routing Network',
  'sd.carSvc': 'Carriers and services',
  'sd.carSvcTip': 'Operating carrier and slot-buying carriers (VSA).',
  'sd.operator': 'Operates the vessel · takes every POD in the rotation',
  'sd.slotBuyer': 'Slot buyer (VSA) · PODs per rotation',
  'sd.sched': 'Upcoming sailings',
  'sd.schedTip': 'Long-term schedule for the next 5 weeks at the VN port.',
  'sd.schedSum': '{a} sailings · {b} blank',
  'sd.activity': 'Activity',
  'sd.activityTip': 'History of changes to the service profile, VSA and schedule.',
  'sd.activitySum': '{n} changes · latest {v}',
  'sd.todo': 'To do',
  'sd.todoTip': 'Remaining tasks for this service.',
  'sd.todoN': '{n} tasks',
  'sd.noTodo': 'Nothing left',
  'sd.mainInfo': 'Main information',
  'sd.mainInfoTip': 'Service profile (TblService · TblServiceRoute). With a locked profile only the sailing schedule can be edited.',
  'sd.owners': 'Owners',
  'sd.ownersTip': 'A service has no customer, so only executors (TblOrgJD): Pricing maintains tariffs and lanes, BKG tracks the sailing schedule.',
  'sd.links': 'Links',
  'sd.linksTip': 'Related screens.',
  'sd.linksSum': '{n} related screens',
});
